// src/components/ToastProvider.jsx
import React, { useEffect, useState } from "react";

/**
 * Usage :
 * window.dispatchEvent(new CustomEvent("toast", {
 *   detail: { type: "success", message: "Produit ajouté au panier !" }
 * }));
 */
export default function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handler = (e) => {
      const { message, type = "info", duration = 4000 } = e.detail || {};
      if (!message) return;

      const id = Date.now() + Math.random();
      setToasts((prev) => [...prev, { id, message, type }]);

      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, duration);
    };

    window.addEventListener("toast", handler);
    return () => window.removeEventListener("toast", handler);
  }, []);

  return (
    <>
      {children}

      {/* Conteneur fixe pour les toasts */}
      <div
        aria-live="polite"
        aria-atomic="true"
        className="position-fixed top-0 end-0 p-3"
        style={{ zIndex: 2000, pointerEvents: "none" }}
      >
        <div className="d-flex flex-column align-items-end gap-2">
          {toasts.map((t) => (
            <div
              key={t.id}
              className={`toast align-items-center text-bg-${
                t.type === "success"
                  ? "success"
                  : t.type === "error"
                  ? "danger"
                  : t.type === "warning"
                  ? "warning"
                  : "secondary"
              } border-0 show`}
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
              style={{ minWidth: "240px", pointerEvents: "auto" }}
            >
              <div className="d-flex">
                <div className="toast-body">{t.message}</div>
                <button
                  type="button"
                  className="btn-close btn-close-white me-2 m-auto"
                  onClick={() =>
                    setToasts((prev) => prev.filter((x) => x.id !== t.id))
                  }
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
